import React, { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { LangContext } from "../../context/lang-context";
import useFetch from "../../hooks/fetchMSSQL-hook";
import NoResults from "../../components/NoResults/NoResults";
import { NavigationContext } from "../../context/navigation-context";
import SearchFilter from "../../components/Filter/SearchFilter";
import moment from "moment";
import WIS from "./WIS";

const LastVi = () => {
  const { TRL_Pack } = useContext(LangContext);
  const { fetchMssqlApi } = useFetch();
  const { setHeaderData } = useContext(NavigationContext);
  const history = useHistory()

  const [data, setData] = useState([]);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const defaultFilter = {
    name: "lastVi",
    page: 1,
    rowsPerPage: 50,
    sortBy: "",
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    machineId: null,
    machineName: "",
    userId: null,
    userName: "",
    machineTags: { id: [], name: [] },
  };

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  });

  const sortDefaults = {
    WI: "DESC",
    VisitCreated: "DESC",
    MachineFullName: "ASC",
    SalesAfterVisitValue: "DESC",
    KP: "ASC",
    StatePercent: "DESC",
    LoadQuantity: "DESC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);
    fetchData(next, settingsFilter?.rowsPerPage, 1);
  };

  const parseThreeState = (val) => {if (val === "false") return false; if (val === "true") return true; return null;};

  const getMachineIdsByTags = (machineTagIds) => {
    return new Promise((resolve, reject) => {
      fetchMssqlApi(
        "tags/getMachineIdsByTags",
        { method: "POST", hideNotification: true, data: { machineTagIds } },
        (response) => { resolve(JSON.stringify(response.map(Number).filter(Number.isFinite)) || [])},
        (err) => reject(err)
      );
    });
  };

  const addKP = (visitId) => {
    let postData = {visitId: visitId};
    fetchMssqlApi( "kp-add", { method: "POST", hideNotification: true, data: postData }, () => {history.push('/kps')});
    fetchData(filter);
  };

  const fetchData = async (f, pageSize, page) => {
    let rowsPerPage = settingsFilter?.rowsPerPage ?? 100;
    if (pageSize != null) rowsPerPage = pageSize;
    const pageNo = Math.max(1, Number(page ?? f?.page) || 1);
    let machineIds = "[]";
    if (f?.machineTags?.id?.length > 0) { machineIds = await getMachineIdsByTags(f.machineTags.id)} 
    if (f?.machineId) {const arr = JSON.parse(machineIds); arr.push(Number(f.machineId)); machineIds = JSON.stringify(arr)}
    fetchMssqlApi(
      "visit-last-wis",
      {
        method: "POST",
        hideNotification: true,
        data: {
          fromCreateDateTime: f.dateTimeRangeFrom,
          toCreateDateTime: f.dateTimeRangeTo,
          machineId: machineIds,
          createUserId: f.userId,
          rowsPerPage: rowsPerPage,
          page: pageNo,
          ...(f?.sortBy && f.sortBy !== "none" ? { sortBy: f.sortBy } : {}),
        },
      },
      (response) => {
        setData(response || []);
      }
    );
  };
  useEffect(() => {
    const handleResize = () => {
      const height = window.innerHeight;
      setWindowHeight(height);

      const visibleRows = Math.floor((height - 350) / 40);
      setFilter((prev) => ({
        ...prev,
        rowsPerPage: Math.min(visibleRows, 100),
      }));
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    setHeaderData({text: "Ostatnie wizyty"});
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <SearchFilter
        filterName="lastVi"
        defaultFilter={defaultFilter}
        onFilterChange={(f) => setFilter((prev) => ({ ...prev, ...f }))}
        onSettingsChange={(s) => setSettingsFilter((prev) => ({ ...prev, ...s }))}
        search={fetchData}
        totalCount={data.length}
        dataList={data}
        forNow
      />
      <div
        className="overflow-auto border custom-scroll"
        style={{
          maxHeight: `${windowHeight - 146}px`,
        }}
      >
        {data.length ? (
          <table className="table table-striped">
            <thead>
              <tr className="text-center headers-color">
                <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("WI")}>Nr wizyty{arrow("WI")}</th>
                <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("VisitCreated")}>Czas zapisu, pobrania danych{arrow("VisitCreated")}</th>
                <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("MachineFullName")}>Automat{arrow("MachineFullName")}</th>
                <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("SalesAfterVisitValue")}>Bieżąca sprzedaż{arrow("SalesAfterVisitValue")}</th>
                <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("KP")}>Rozliczenie monet{arrow("KP")}</th>
                <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("StatePercent")}>Stan automatu <br/> po doładowaniu{arrow("StatePercent")}</th>
                <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("LoadQuantity")}>Doładowanie{arrow("LoadQuantity")}</th>
                <th>Korekta stanu</th>
              </tr>
            </thead>
            <tbody>
              {data
                .map((entry, idx) => (
                  <tr key={idx} className="text-center">
                    <td>
                      <div className='d-flex flex-column justify-content-center align-items-center text-center'>
                        <div className="btn btn-sm btn-outline-primary">
                          {entry.WI}</div>
                      </div>
                    </td> 
                    <td>
                      <div className='d-flex flex-column justify-content-center align-items-center text-center'>
                        <div className="btn text-nowrap">{entry.VisitCreated}</div>
                        {entry.MachineConfigLoadedDateTime !== '' && (<div className="btn text-nowrap">{entry.MachineConfigLoadedDateTime}</div>)}
                      </div>
                    </td>
                    <td>{entry.MachineFullName}</td>
                    <td className="px-1 py-0">
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                      {entry.SalesWarehouseOperationId !== null && (<Link to={`/pa/${entry.SalesWarehouseOperationId}`} className="btn text-nowrap btn-sm btn-outline-secondary">
                        {entry.PA}</Link>)}
                      <div className="btn text-nowrap">{entry.SalesAfterVisitValue != null && (
                        `${String(entry.SalesAfterVisitValue).replace('.', ',')} zł (${entry.SalesAfterVisitQuantity} szt.)`
                      )}
                      </div>
                    </div>
                    </td>
                    <td>
                      {entry.MachineCoinInventoryId !== null  && (<button className="btn text-nowrap btn-sm btn-outline-success">{entry.KP}</button>)}
                      {entry.MachineCoinInventoryId === null  && (<button className="btn text-nowrap btn-sm btn-outline-success" onClick={() => addKP(entry.VisitId)}>Dodaj KP</button>)}
                    </td>
                    <td>
                      <div className='d-flex flex-column justify-content-center align-items-center'>
                        {entry.MachineInventoryId !== null && (<>
                          <Link to={`/inm/${entry.MachineInventoryId}`} className="btn text-nowrap btn-sm btn-outline-danger">
                            {entry.INm}</Link>
                          <div className="btn text-nowrap">{entry.StateAndCapacity} ({entry.StatePercent}%)</div></>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className='d-flex flex-column justify-content-center align-items-center'>
                        {entry.LoadMachineInventoryId !== null && (<Link to={`/do/${entry.LoadMachineInventoryId}`} className="btn text-nowrap btn-sm btn-outline-info">
                          {entry.DO}</Link>)}
                        {entry.LoadQuantity !== null && (<div className="btn text-nowrap">{entry.LoadQuantity} szt.</div>)}
                        {entry.LoadQuantity === null && (<div className="btn text-nowrap">-</div>)}
                        {entry.ConfigChange !== 0 && (<div className="btn text-nowrap">Zmiana konfiguracji</div>)}
                      </div>
                    </td>
                    <td>
                      <div className='d-flex flex-column justify-content-center align-items-center'>
                        {entry.CorrectionId !== null && (<Link to={`/ko/${entry.CorrectionId}`} className="btn text-nowrap btn-sm btn-outline-secondary mt-1">{entry.KO}</Link>)}
                        {entry.KOComment !== null && (<div className="btn">Powód: {entry.KOComment}</div>)}
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <NoResults />
        )}
      </div>
    </div>
  );
};

export default LastVi;